import { Stack, StackProps, Typography, alpha, styled } from '@mui/material';

const LocationPinIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
    <path
      d="M12.5098 6.60807C12.5096 4.1181 10.4907 2.09961 8.00065 2.09961C5.51075 2.09974 3.49231 4.11817 3.49219 6.60807C3.49219 7.32641 3.76479 8.14686 4.2168 9.00065C4.66537 9.84792 5.2695 10.689 5.88346 11.4395C6.49611 12.1882 7.11011 12.8367 7.57161 13.2982C7.73653 13.4631 7.88257 13.603 8.00065 13.7155C8.11875 13.603 8.2647 13.4632 8.42969 13.2982C8.89121 12.8367 9.50579 12.1883 10.1185 11.4395C10.7324 10.689 11.3366 9.84791 11.7852 9.00065C12.2372 8.14686 12.5098 7.32641 12.5098 6.60807ZM9.10091 6.39974C9.10091 5.7923 8.60872 5.29959 8.0013 5.29948C7.39379 5.29948 6.90104 5.79223 6.90104 6.39974C6.90106 7.00724 7.3938 7.5 8.0013 7.5C8.60871 7.49988 9.1009 7.00717 9.10091 6.39974ZM13.5098 6.60807C13.5098 7.55927 13.1557 8.548 12.6686 9.4681C12.1781 10.3947 11.5301 11.293 10.8919 12.0729C10.2526 12.8543 9.61491 13.5277 9.13737 14.0052C8.89838 14.2442 8.69837 14.4349 8.55794 14.5664C8.48779 14.6321 8.43215 14.6832 8.39388 14.7181C8.37474 14.7355 8.35985 14.7493 8.34961 14.7585C8.3446 14.763 8.34065 14.7664 8.33789 14.7689C8.3365 14.7701 8.33543 14.7714 8.33464 14.7721L8.33333 14.7728V14.7734L8.00065 15.0684L7.66862 14.7734L7.66406 14.7689C7.66131 14.7664 7.65736 14.763 7.65234 14.7585C7.64211 14.7493 7.62721 14.7355 7.60807 14.7181C7.5698 14.6832 7.51422 14.6322 7.44401 14.5664C7.30357 14.4349 7.10363 14.2443 6.86458 14.0052C6.38699 13.5276 5.74878 12.8544 5.10938 12.0729C4.47123 11.293 3.82321 10.3947 3.33268 9.4681C2.84563 8.54805 2.49219 7.5592 2.49219 6.60807C2.49231 3.56589 4.95847 1.09974 8.00065 1.09961C11.0429 1.09961 13.5096 3.56581 13.5098 6.60807ZM10.1009 6.39974C10.1009 7.55945 9.16099 8.49988 8.0013 8.5C6.84151 8.5 5.90106 7.55952 5.90104 6.39974C5.90104 5.23994 6.8415 4.29948 8.0013 4.29948C9.161 4.29959 10.1009 5.24001 10.1009 6.39974Z"
      fill="currentColor"
    />
  </svg>
);

export const Container = styled('div', { shouldForwardProp: (prop) => prop !== 'showCheckbox' })<{
  showCheckbox?: boolean;
}>(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: '2rem',
  background: '#FEFEFE',
  borderRadius: '14px',
  padding: '16px',
  boxShadow: '0 1px 8px 0 rgba(0, 0, 0, 0.15)',
  [theme.breakpoints.down('lg')]: {
    flexWrap: 'wrap',
  },
}));

export const ImageWrapper = styled('div')(({ theme }) => ({
  position: 'relative',
  borderRadius: '12px',
  overflow: 'hidden',
  flexShrink: 0,
  width: '219px',
  height: '129px',
  aspectRatio: '73/43',
  [theme.breakpoints.down('lg')]: {
    width: '100%',
    height: 'auto',
    aspectRatio: '73/43',
  },
}));

export const Image = styled('img')<{ isDefault: boolean }>(() => ({
  objectFit: 'cover',
  cursor: 'pointer',
  width: '100%',
  height: '100%',
  position: 'absolute',
  top: 0,
  left: 0,
}));

export const ImagePlaceholder = styled('div')(({ theme }) => ({
  cursor: 'pointer',
  width: '100%',
  height: '100%',
  backgroundColor: theme.palette.grey[200],
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'center',

  '& svg': {
    fontSize: '4rem',
    color: theme.palette.grey[600],
    [theme.breakpoints.down('lg')]: {
      fontSize: '15rem',
    },
    [theme.breakpoints.down('md')]: {
      fontSize: '10rem',
    },
  },
}));

export const TitleContainer = styled(Stack)(({ theme }) => ({
  gap: '0.5rem',
  cursor: 'pointer',
  border: `1px solid transparent`,
  padding: '0.25rem 0',
  transition: 'background-color 0.3s ease, border 0.3s ease',
  width: '236px',
  flexShrink: 0,
  ':hover': {
    backgroundColor: alpha(theme.palette.accent.main, 0.1),
  },
}));

export const Title = styled(Typography)(({ theme }) => ({
  fontSize: '1.125rem',
  fontWeight: 600,
  lineHeight: '120%',
  color: theme.palette.grey[900],
  margin: 0,
  display: '-webkit-box',
  WebkitLineClamp: 2,
  WebkitBoxOrient: 'vertical',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
}));

export const TrafficValue = styled(Typography)(({ theme }) => ({
  fontSize: '0.75rem',
  fontWeight: 400,
  color: theme.palette.grey[600],
  margin: 0,
}));

export const Specification = styled(Stack, {
  shouldForwardProp: (prop) => prop !== 'showHoverEffect',
})<{ showHoverEffect?: boolean }>(({ theme, showHoverEffect }) => ({
  position: 'relative',
  backgroundColor: '#F5F5F7',
  borderRadius: '13px',
  padding: '4px 8px',
  flexDirection: 'column',
  alignItems: 'flex-start',
  gap: '2px',
  width: '174px',
  flex: '0 0 174px',
  overflow: 'hidden',
  ...((showHoverEffect && {
    cursor: 'pointer',
    transition: 'background-color 0.3s ease',
    ':hover': {
      backgroundColor: alpha(theme.palette.accent.main, 0.1),
    },
  }) ||
    {}),
}));

export const SpecificationTitle = styled(Typography)(({ theme }) => ({
  fontSize: '0.625rem',
  fontWeight: 500,
  textTransform: 'uppercase',
  color: theme.palette.grey[600],
  margin: 0,
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
}));

export const SpecificationValue = styled(Typography)(({ theme }) => ({
  fontSize: '0.625rem',
  fontWeight: 400,
  color: theme.palette.grey[800],
  margin: 0,
  minHeight: '1rem',
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  width: '100%',
  maxWidth: '100%',
}));

export const TypeBadge = styled(({ children, ...props }: StackProps) => (
  <Stack {...props} direction="row" alignItems="center">
    <LocationPinIcon /> <p>{children}</p>
  </Stack>
))({
  borderRadius: '8px',
  gap: '4px',
  padding: '4px 8px',
  alignSelf: 'flex-start',

  '& > p': {
    margin: 0,
    fontSize: '0.75rem',
    fontWeight: 400,
    lineHeight: '160%',
  },
});
